import * as React from "react";
// import { pure } from 'recompose'

import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    isVisible,
    onExplorerSearch,
    onPenSearchIncidents,
    explorersearch,
    onExplorerSearchChange,
    placeholdersearch,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isVisible}>
      <StyledComponent.ModalContainerInsider
        isVisible={isVisible}
        style={{
          overflow: "visible",
          width: "400px",
          backgroundColor: "white",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <StyledComponent.BreadContainerBaliseForm
          onSubmit={onExplorerSearch}
          style={{
            background: "transparent",
            borderRadius: "5px",
            border: "1px solid #979797",
            width: "auto",
            cursor: "pointer",
            marginRight: "10px",
          }}
        >
          <StyledComponent.Input
            maxLength={50}
            autoComplete="OFF"
            type="text"
            value={explorersearch}
            onChange={onExplorerSearchChange}
            placeholder={placeholdersearch}
            name="explorersearch"
            style={{
              backgroundColor: "transparent",
              paddingLeft: "35px",
              boxSizing: "border-box",
              marginRight: "10px",
              color: "#9a9696",
            }}
          />
          <StyledComponent.Icon
            style={{ width: "25px", left: "5px" }}
            onClick={onExplorerSearch}
          >
            <StyledIcon explorer={true} color="#979797" />
          </StyledComponent.Icon>
        </StyledComponent.BreadContainerBaliseForm>
        <div className="closeBox" onClick={onPenSearchIncidents}>
          <StyledComponent.Icon style={{ width: "25px" }}>
            <StyledIcon delected={true} color="white" />
          </StyledComponent.Icon>
        </div>
      </StyledComponent.ModalContainerInsider>
    </StyledComponent.ModalContainer>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  isVisible?: boolean;
  onExplorerSearch?: any;

  explorersearch?: any;
  onExplorerSearchChange?: any;
  onPenSearchIncidents?: any;
  placeholdersearch?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/modal/search-incidents/component.tsx